import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Seo from "@/components/feature/Seo";
import Breadcrumb from "@/components/feature/Breadcrumb";
import MangaCard from "@/components/feature/MangaCard";
import { categories, mangaList } from "@/mocks/manga";

export default function CategoryPage() {
  const { slug } = useParams();
  const current = categories.find((c) => c.slug === slug) ?? categories[0];
  const items = mangaList.filter((m) => m.category === current.slug);

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      name: `${current.name}漫画分类-免费阅读-178漫画网`,
      url: `https://swimchats.github.io/category/${current.slug}`,
      description: `在178漫画网免费阅读${current.name}题材漫画，涵盖恋爱、校园、日常等多种作品，无需付费即可在线浏览完整章节与高清画面。`,
      isPartOf: { "@type": "WebSite", name: "178漫画网", url: "https://swimchats.github.io/" },
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "首页", item: "https://swimchats.github.io/" },
        { "@type": "ListItem", position: 2, name: "漫画分类", item: "https://swimchats.github.io/category/love" },
        { "@type": "ListItem", position: 3, name: `${current.name}漫画` },
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-background-50">
      <Seo
        title={`${current.name}漫画-免费阅读${current.name}题材漫画全集-178漫画网`}
        description={`在178漫画网免费阅读${current.name}漫画，在线浏览${current.name}题材中文故事，无需付费即可享受完整章节和高清画面。${current.name}漫画,免费阅读,178漫画网。`}
        keywords={`${current.name}漫画,免费阅读,漫画全集,178漫画网`}
        canonical={`https://swimchats.github.io/category/${current.slug}`}
        jsonLd={jsonLd}
      />
      <Navbar />
      <main className="mx-auto max-w-7xl px-4 md:px-6 pt-24 md:pt-28 pb-14">
        <div className="pt-4">
          <Breadcrumb
            items={[
              { label: "漫画分类", to: "/category/love" },
              { label: `${current.name}漫画` },
            ]}
          />
        </div>

        <header className="mt-6 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
          <div>
            <h1 className="font-heading text-2xl text-foreground-950 md:text-3xl">{current.name}漫画</h1>
            <p className="mt-2 text-sm text-foreground-600">共 {items.length} 部免费漫画，无需付费即可在线阅读</p>
          </div>
          <span className="flex items-center gap-1 rounded-full bg-accent-100 px-3 py-1.5 text-xs font-medium text-accent-700">
            <i className="ri-fire-line"></i>全部免费
          </span>
        </header>

        <div className="mt-6 flex flex-wrap items-center gap-2">
          {categories.map((c) => {
            const active = c.slug === current.slug;
            return (
              <Link
                key={c.slug}
                to={`/category/${c.slug}`}
                className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  active ? "bg-primary-500 font-medium text-background-50" : "bg-background-100 text-foreground-700 hover:bg-background-200"
                }`}
              >
                <i className="ri-book-2-line"></i>
                {c.name}漫画
                <span className={active ? "text-background-100" : "text-foreground-400"}>({mangaList.filter((m) => m.category === c.slug).length})</span>
              </Link>
            );
          })}
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
          {items.map((m) => (
            <MangaCard key={m.id} manga={m} />
          ))}
        </div>

        {items.length === 0 && (
          <div className="mt-10 flex flex-col items-center gap-3 rounded-lg border border-background-200 bg-background-100 py-16 text-center">
            <i className="ri-emotion-sad-line text-4xl text-foreground-400"></i>
            <p className="text-sm text-foreground-600">该分类下暂无漫画，看看其他分类吧</p>
            <Link to="/category/love" className="mt-2 rounded-full bg-primary-500 px-5 py-2 text-sm text-background-50 hover:bg-primary-600">
              返回热门分类
            </Link>
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}